import { render } from "./awsElasticsearch.vue?vue&type=template&id=3a356343"
import script from "./awsElasticsearch.vue?vue&type=script&lang=js"
export * from "./awsElasticsearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__